import React, { useMemo } from 'react';
import parse from 'html-react-parser';

interface InlineStylesProps {
  styles: string;
  nonce?: string;
}

export function InlineStyles({ styles, nonce }: InlineStylesProps) {
  const replacedStyles = useMemo(
    () => styles.replace(/#html-body/g, ''),
    [styles]
  );

  const elementToParse = nonce
    ? `<style nonce="${nonce}">${replacedStyles}</style>`
    : `<style>${replacedStyles}</style>`;

  return <>{parse(elementToParse, { trim: true })}</>;
}
